// React
import { useState } from "react";
// Translation
import i18n from "i18next";
// React Bootstrap
import { Button, Form, Modal } from "react-bootstrap";
// FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";

////////////////////////////////
//           Props            //
////////////////////////////////

interface ConfigProps {
  config: config;
  setConfig: (config: ConfigProps["config"]) => void;
  show: boolean;
  onHide: (value: boolean) => void;
}

////////////////////////////////
//         Interfaces         //
////////////////////////////////

interface config {
  structureMapEndpoint: string;
  terminologyEndpoint: string;
}

const ConfigModal: React.FC<ConfigProps> = (props: ConfigProps) => {
  /////////////////////////////////////
  //      Constants / ValueSet       //
  /////////////////////////////////////

  const { config, setConfig, show, onHide } = props;
  const [conftemp, setConfigTemp] = useState({ ...config });

  ////////////////////////////////
  //           Actions          //
  ////////////////////////////////

  const handleClose = () => {
    onHide(false);
    setConfigTemp(config);
  };

  const validate = () => {
    setConfig(conftemp);
    onHide(false);
  };

  //////////////////////////////
  //          Content         //
  //////////////////////////////

  return (
    <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      {/* HEADER */}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center gap-3">
            <h2 className="m-0">{i18n.t("title.structuremapconfig")}</h2>
            <FontAwesomeIcon icon={faGear} />
          </div>
        </Modal.Title>
      </Modal.Header>

      {/* BODY */}
      <Modal.Body>
        <Form className="ms-4 me-3 lh-sm">
          <Form.Group className="mb-3">
            <Form.Label className="mb-2">
              <h5 className="m-0">{i18n.t("modal.structuremapendpoint")}</h5>
            </Form.Label>

            <Form.Control
              type="text"
              value={conftemp.structureMapEndpoint}
              onChange={(e) =>
                setConfigTemp({
                  ...conftemp,
                  structureMapEndpoint: e.target.value,
                })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="mb-2">
              <h5 className="m-0">{i18n.t("modal.terminologyendpoint")}</h5>
            </Form.Label>

            <Form.Control
              type="text"
              value={conftemp.terminologyEndpoint}
              onChange={(e) =>
                setConfigTemp({
                  ...conftemp,
                  terminologyEndpoint: e.target.value,
                })
              }
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      {/* FOOTER */}
      <Modal.Footer>
        <Button variant="danger" onClick={validate}>
          {i18n.t("button.validate")}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          {i18n.t("button.cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfigModal;
